var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWfArrowExpand = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3171742,5.57042158 C11.818645,5.04392548 11.818645,4.19136881 11.3171742,3.66628424 L5.83527808,-2.04683354 C5.32842956,-2.57332964 4.50900205,-2.57191812 4.00215353,-2.04683354 C3.50068272,-1.52033745 3.50068272,-0.668486536 4.00215353,-0.141990444 L8.57320118,4.61835291 L4.00215353,9.37728474 C3.50068272,9.90378083 3.50068272,10.7556317 4.00215353,11.2821278 C4.50900205,11.8079182 5.32842956,11.8079182 5.83527808,11.2821278 L11.3171742,5.57042158 Z",
    id: "Path",
    fill: "#BEC8D2",
    fillRule: "nonzero",
    transform: "translate(7.659664, 4.617647) rotate(-270.000000) translate(-7.659664, -4.617647) "
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWfArrowExpand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wf_arrow_expand.06e6e9bd.svg";
export { ForwardRef as ReactComponent };